<rk-modal-wrapper
  [title]="'SCHEDULE.PROGRAMS.PROGRAM_PREVIEW' | translate"
  [larger]="true"
  [submitText]="'SHARE.MODAL.CLOSE' | translate"
  [showCancel]="false"
  [style]="modalStyle()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  (submitted)="onCancel()"
>
  <rk-colored-hint [type]="'warning'">
    {{ 'SCHEDULE.PROGRAMS.PREVIEW_SAMPLE' | translate }}
  </rk-colored-hint>

  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <div class="preview">
      <div class="preview-header">
        <div class="title" translate>MEDIA.COLUMNS.TITLE</div>
        <div class="artist" translate>MEDIA.COLUMNS.ARTIST</div>
        <div class="playlist" translate>MODAL.ADD_PLAYLIST.PLAYLIST</div>
      </div>
      <div class="preview-content">
        <div class="preview-line" *ngIf="trackIntro">
          <div class="title">{{ trackIntro.title }}</div>
          <div class="artist">{{ trackIntro.artist }}</div>
          <div class="playlist"><span class="tag">INTRO</span></div>
        </div>
        <ng-container *ngFor="let playlistPreview of programPreview">
          <div class="preview-line" *ngFor="let track of playlistPreview.tracks">
            <div class="title">{{ track.title }}</div>
            <div class="artist">{{ track.artist }}</div>
            <div class="playlist">
              <rk-playlist-icon [playlist]="playlistPreview.playlist"></rk-playlist-icon>
              {{ playlistPreview.playlist.name }}
            </div>
          </div>
        </ng-container>
        <div class="preview-line" *ngIf="trackExtro">
          <div class="title">{{ trackExtro.title }}</div>
          <div class="artist">{{ trackExtro.artist }}</div>
          <div class="playlist"><span class="tag">EXTRO</span></div>
        </div>
      </div>
    </div>
    <div class="new-cycle">
      <rk-button
        [btnStyle]="'flat'"
        [label]="
          (isLoadingCycle$ | async)
            ? ('SCHEDULE.PROGRAMS.GENERATION' | translate)
            : ('SCHEDULE.PROGRAMS.GENERATE_CYCLE' | translate)
        "
        [faIcon]="'fa-eye'"
        [loading]="isLoadingCycle$ | async"
        (click)="newCycle()"
      ></rk-button>
    </div>
  </ng-container>
</rk-modal-wrapper>

<ng-template #loading>
  <div class="loader">
    <rk-loader [size]="60" [isLoading]="true" [center]="true"></rk-loader>
  </div>
</ng-template>
